import React from 'react';
import axios from "axios";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';

const colunas = ['Pedido', 'Data emissão', 'Data entrega', 'Situação', 'Código item',
'Descrição do item', 'Quantidade', 'U.M.', 'Preço Unit', 'Desconto', 'Acréscimo', 'Preço Total', 'Cliente',
'Transportadora', 'Cond. Pagto', 'Forma Pagto', 'Tipo de pedido'];


class ConsultaInteligente extends React.Component {
  constructor(props) {
    super(props);

    this.load = this.load.bind(this);
    this.onChangePeriodo = this.onChangePeriodo.bind(this);
    this.onChangeTipo = this.onChangeTipo.bind(this);
    this.loadPedidos = this.loadPedidos.bind(this);
    this.loadOrcamentos = this.loadOrcamentos.bind(this);

    this.state = {
      pedidos : [],
      orcamentos : [],
      tipo: "pedido", // pedido ou orçamento
      periodo: "mesAtual", //mesAtual ou mesAnterior
      dados: []  
    };
  };

  async componentDidMount() {
    await this.load();
  };

  async load() {
    await this.loadPedidos();
  };

  async loadPedidos() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/pedidos/pivotgrid?periodo=${this.state.periodo}`,
           this.props.parameters()
      )
      .then((response) => {
        this.setState({ pedidos: response.data.pedidos });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      })

      /*
      const colunas = ['Pedido', 'Data emissão', 'Data entrega','Situação', 'Código item',
                       'Descrição do item', 'Quantidade', 'U.M.', 'Preço Unit', 'Desconto', 'Acréscimo', 
                       'Preço Total', 'Cliente',
                       'Transportadora', 'Cond. Pagto', 'Forma Pagto', 'Tipo de pedido'];
      */

     let linhas = [];
      for(let pedido of this.state.pedidos){
        if(pedido.itens.length > 0){
          for(let item of pedido.itens){
            let linha = [
              pedido.codigo,
              moment(pedido.data).format("DD/MM/YYYY"),
              moment(pedido.previsaoEntrega).format("DD/MM/YYYY"),
              pedido.situacao.desc,
              item.produto.cod,
              item.produto.desc,
              item.quantidade,
              item.produto.unid,
              item.produto.preco.precoUnit,
              item.produto.preco.pDesconto,
              item.produto.preco.pAcrescimo,
              item.produto.preco.precoTotalComImpostosFinal,
              pedido.cliente.desc,
              pedido.transportadora.desc,
              pedido.condPagto.desc,
              pedido.formaPagto.desc,
              pedido.tipoPedido.desc,
            ];

            linhas.push(linha);
          };
        };
      };


      this.setState( { dados: [
        colunas,
        ...linhas
      ] 
      }); 
  };

  async loadOrcamentos() {
  };

  onChangePeriodo(e) {
    this.setState(
      { periodo: e.target.value },
      () => {
        this.load();
      }
    );
  };

  onChangeTipo(e) {
    this.setState(
      { tipo: e.target.value },
      () => {
        this.load();
      }
    );
  };

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />

        <div className="container-scroller font-app">
          <NavBar title="Consulta Inteligente"/>
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"consulta-inteligente"} />
            <div className="main-panel">
              <div className="content-wrapper">
                
                {/* <TitleAndDescription
                  title="Consulta inteligente"
                  description="Avalie as informações de pedido da melhor forma para sua estratégia de vendas."
                /> */}

                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/calendar.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "28px" }}
                                />

                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Período
                                  </small>
                                  <div className="dropdown">
                                    {}
                                    <select
                                      className="no-border"
                                      style={{ fontWeight: "bold" }}
                                      value={this.state.periodo}
                                      onChange={(e) => this.onChangePeriodo(e)}
                                    >
                                      <option value="mesAtual">
                                        Mês Atual
                                      </option>
                                      <option value="mesAnterior">
                                        Mês Anterior
                                      </option>
                                    </select>
                                    <div
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuLinkA"
                                    >
                                      <a className="dropdown-item" href="#">
                                        Mês anterior
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div  
                      className="float-left width-100"
                      style={{
                        backgroundColor: "#FFF",
                        overflowY: "hidden",
                      }}
                    >
                      <PivotTableUI
                        data={this.state.dados}
                        onChange={(s) => this.setState(s)}
                        {...this.state}
                      />
                    </div>
                  </div>
                  
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>


      </React.Fragment>
    );
  };
};

export default ConsultaInteligente;